// src/store/api/providerApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const providerDocsApi = createApi({
  reducerPath: "providerDocsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "users/provider-docs",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().userSlice?.token;
      // ✅ or from redux state
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addDocs: builder.mutation({
      query: ({
        docsType,
        ProviderId,
        userType,
        title,
        fileUrl,
        from,
        startTime,
        endTime,
        description,
      } = {}) => {
        const payload = {};

        if (docsType != null) payload.docsType = docsType;
        if (ProviderId != null) payload.ProviderId = ProviderId; // if backend expects this
        if (userType != null) payload.userType = userType;
        if (title != null) payload.title = title;
        if (fileUrl != null) payload.fileUrl = fileUrl;
        if (from != null) payload.from = from;
        if (startTime != null) payload.startTime = startTime;
        if (endTime != null) payload.endTime = endTime;
        if (description != null) payload.description = description;

        return {
          url: `/`, // adjust endpoint if needed (e.g., `/provider-docs`)
          method: "POST",
          body: payload,
        };
      },
    }),

    updateDocs: builder.mutation({
      query: ({
        docsType,
        ProviderId,
        userType,
        title,
        fileUrl,
        from,
        startTime,
        endTime,
        description,
        id
      } = {}) => {
        const payload = {};

        if (docsType != null) payload.docsType = docsType;
        if (ProviderId != null) payload.ProviderId = ProviderId; 
        if (userType != null) payload.userType = userType;
        if (title != null) payload.title = title;
        if (fileUrl != null) payload.fileUrl = fileUrl;
        if (from != null) payload.from = from;
        if (startTime != null) payload.startTime = startTime;
        if (endTime != null) payload.endTime = endTime;
        if (description != null) payload.description = description;

        return {
          url: `/me/${id}`, 
          method: "PATCH",
          body: payload,
        };
      },
    }),

    getDocs: builder.query({
      query: () => {
        return {
          url: "/me",
          method: "GET",
        };
      },
    }),

    getOneProviderDocs: builder.query({
      query: ({ id }) => {
        return {
          url: `/public/${id}`,
          method: "GET",
        };
      },
    }),
    deleteDoc: builder.mutation({
      query: (docId) => ({
        url: `/${docId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddDocsMutation,
  useGetDocsQuery,
  useUpdateDocsMutation,
  useDeleteDocMutation,
  useGetOneProviderDocsQuery,
} = providerDocsApi;
